import { Component, Input } from '@angular/core';

@Component({ selector: 'status', templateUrl: 'status.component.html' })
export class StatusComponent {

    @Input() userStatus: string;
    @Input() activitiesCount: any;


}